import React from 'react';
import { CTA } from '../Home';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/20/solid';

const blogPosts = [
  {
    id: 1,
    title: 'Trasferimenti da e per aeroporti',
    href: '/contatti',
    value: 'trasferimenti-aeroporti',
    description: 'Collegamenti puntuali con tutti gli aeroporti del nord Italia.',
    imageUrl: '/img/joseph-barrientos-JGhje7WBHdg-unsplash-1-scaled.jpg',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    author: {
      name: 'Michael Foster',
      imageUrl:
        'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  {
    id: 2,
    title: 'Trasferimenti aziendali e meeting',
    href: '/contatti',
    value: 'trasferimenti-aziendali-meeting',
    description: 'Comfort e puntualità per i tuoi spostamenti professionali.',
    imageUrl: '/img/pexels-negative-space-34092-scaled.jpg',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    author: {
      name: 'Lindsay Walton',
      imageUrl:
        'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  {
    id: 3,
    title: 'Viaggi su lunghe distanze',
    href: '/contatti',
    value: 'viaggi-lunghe-distanze',
    description: 'Raggiungi qualsiasi destinazione con comodità e sicurezza.',
    imageUrl: '/img/pexels-robert-so-11003995-scaled.jpg',
    date: 'Feb 12, 2020',
    datetime: '2020-02-12',
    author: {
      name: 'Tom Cook',
      imageUrl:
        'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  {
    id: 4,
    title: 'Matrimoni ed eventi speciali',
    href: '/contatti',
    value: 'matrimoni-eventi-speciali',
    description: 'Servizi eleganti per accompagnare i tuoi momenti più importanti.',
    imageUrl: '/img/pexels-craig-adderley-2306281-scaled.jpg',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    author: {
      name: 'Michael Foster',
      imageUrl:
        'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  {
    id: 5,
    title: 'Visite guidate in Franciacorta',
    href: '/contatti',
    value: 'visite-guidate-franciacorta',
    description: 'Tour personalizzati tra cantine e paesaggi della Franciacorta.',
    imageUrl: '/img/AdobeStock_506130149-scaled.jpeg',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    author: {
      name: 'Lindsay Walton',
      imageUrl:
        'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  {
    id: 6,
    title: 'Outlet Village',
    href: '/contatti',
    value: 'outlet-franciacorta-village',
    description: 'Shopping senza pensieri con trasporto privato da e per l’outlet.',
    imageUrl: '/img/heidi-fin-2TLREZi7BUg-unsplash-scaled.jpg',
    date: 'Feb 12, 2020',
    datetime: '2020-02-12',
    author: {
      name: 'Tom Cook',
      imageUrl:
        'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
];

export default function Servicies() {
  return (
    <>
      <div className="hidden bg-white py-24 sm:py-32">
        <div className="relative isolate">
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="mx-auto max-w-2xl max-md:px-6 lg:mx-0 lg:max-w-none">
              <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                I nostri servizi
              </h2>
              <p className="mt-2 text-lg/8 text-gray-600">
                Soluzioni su misura per ogni tipo di viaggio: professionale, turistico o personale.
              </p>
            </div>
            <div className="mx-auto mt-16 flex max-w-2xl flex-col gap-16 bg-white/75 px-6 py-16 shadow-lg ring-1 ring-gray-900/5 sm:rounded-3xl sm:p-8 lg:mx-0 lg:max-w-none lg:flex-row lg:items-center lg:py-20 xl:gap-x-20 xl:px-20">
              <img
                alt=""
                src="/img/Gemini_Generated_Image_wlnnhkwlnnhkwlnn.png"
                className="h-96 w-full flex-none rounded-2xl object-cover lg:h-auto lg:max-w-sm"
              />
              <div className="w-full flex-auto">
                <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-950 sm:text-5xl">
                  Il Miglior servizio NCC per le Olimpiadi Milano Cortina 2026
                </h2>
                <p className="mt-6 text-pretty text-lg/8 text-gray-600">
                  Offriamo trasferimenti esclusivi e personalizzati da Verona e Milano verso tutte
                  le principali località olimpiche, garantendo comfort, puntualità e sicurezza.
                </p>
                <ul className="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 text-base/7 text-gray-950 sm:grid-cols-2">
                  {[].map(benefit => (
                    <li key={benefit} className="flex gap-x-3">
                      <CheckCircleIcon
                        aria-hidden="true"
                        className="h-7 w-5 flex-none text-indigo-500"
                      />
                      {benefit}
                    </li>
                  ))}
                </ul>
                <div className="mt-10 flex">
                  <a
                    href="/contatti"
                    className="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-300"
                  >
                    Prenota ora il Tuo transfer NCC per le Olimpiadi 2026
                    <span aria-hidden="true">&rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            aria-hidden="true"
            className="absolute inset-x-0 -top-16 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl"
          >
            <div
              style={{
                clipPath:
                  'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)',
              }}
              className="aspect-[1318/752] w-[82.375rem] flex-none bg-gradient-to-r from-[#9fd6fc] to-[#8680fd] opacity-50"
            />
          </div>
        </div>
      </div>
      <div className="relative">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            {blogPosts.map(post => (
              <article
                key={post.id}
                className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-8 pt-80 sm:pt-48 lg:pt-80"
              >
                <img
                  alt={post.title}
                  title={post.title}
                  src={post.imageUrl}
                  className="absolute inset-0 -z-10 size-full object-cover"
                />
                <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40" />
                <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10" />

                <div className="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm/6 text-gray-300">
                  <div className="-ml-4 hidden items-center gap-x-4">
                    <svg viewBox="0 0 2 2" className="-ml-0.5 size-0.5 flex-none fill-white/50">
                      <circle r={1} cx={1} cy={1} />
                    </svg>
                    <div className="flex gap-x-2.5">
                      <img
                        alt=""
                        src={post.author.imageUrl}
                        className="size-6 flex-none rounded-full bg-white/10"
                      />
                      {post.author.name}
                    </div>
                  </div>
                </div>
                <h3 className="mt-3 text-lg/6 font-semibold text-white">
                  <Link to={post.href} state={{ service: post.value }}>
                    <span className="absolute inset-0" />
                    {post.title}
                  </Link>
                </h3>
              </article>
            ))}
          </div>
        </div>
      </div>
      <CTA />
    </>
  );
}
